import {
  gAuthEnableUrl,
  gAuthLoginUrl,
  gAuthUserDataUrl,
} from "../constant/Api";
import { baseApi } from "./api";

export const googleAuthApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    gAuthLogin: builder.mutation({
      query: (post) => ({
        url: gAuthLoginUrl,
        method: "POST",
        body: post,
      }),
    }),
    gAuthUserData: builder.query({
      query: () => ({
        url: gAuthUserDataUrl,
        method: "GET",
      }),
    }),
    gAuthEnable: builder.mutation({
      query: (post) => ({
        url: gAuthEnableUrl,
        method: "POST",
        body: post,
      }),
    })
  }),
});

export const {
  useGAuthEnableMutation,
  useGAuthLoginMutation,
  useGAuthUserDataQuery,
} = googleAuthApi;
